// Generated by client/version.sh
export const version = {
  commit: '20253ac',
  commit_full: '20253acc2387f852caa9801cce0e4e95a86e6843',
  tag: 'v0.1.142',
  time: '2023-12-18T07:14:05Z',
};
